import { inject } from "aurelia-framework";
import { DialogController } from "aurelia-dialog";

@inject(DialogController)
export class KMessageDialog {
  message: string;
  title?: string;
  mode: "error" | "okcancel" = "error";
  okButtonTextKey: string;
  cancelButtonTextKey: string;

  constructor(private controller: DialogController) {}

  activate(model: {
    mode: "error" | "okcancel";
    message: string;
    title?: string;
  }) {
    this.mode = model.mode;
    this.message = model.message;
    this.title = model.title;
    this.okButtonTextKey = model.mode == "okcancel" ? "ok" : "";
    this.cancelButtonTextKey = model.mode == "okcancel" ? "cancel" : "close";
  }
}
